module.exports = __webpack_public_path__ + "static/media/camera-flip.aae82936.png";